import { FloatingHeader } from '@/components/ui/floating-header';

export const Header = () => {
  return <FloatingHeader />;
};
